import { render, staticRenderFns } from "./newInternetBar.vue?vue&type=template&id=2f352874&scoped=true"
import script from "./newInternetBar.vue?vue&type=script&lang=js"
export * from "./newInternetBar.vue?vue&type=script&lang=js"
import style0 from "./newInternetBar.vue?vue&type=style&index=0&id=2f352874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f352874",
  null
  
)

export default component.exports